<template lang="html">
    <div class="app">

        <Header></Header>
        <TypesMenu></TypesMenu>

        <div class="section section-grey py-5" v-if="rank">
            <div class="container">
                <h1 class="text-center mb-4">{{rank["title-main"]}}</h1>
                <div class="text-center">
                    <router-link :to="{name: 'index'}" class="btn btn-lg btn-light w-100"><i class="fas fa-chevron-left"></i> Inapoi la categorii</router-link>
                </div>
            </div>
        </div>
        <div class="section section-white section-shadow py-5" v-if="rank">
            <div class="container">
                <div class="card mb-5" v-for="(place, index) in rank.places">
                    <div class="" v-for="(member, k) in place">
                        <div class="card-header mb-2" v-bind:class="{'': index <=3}">
                            <div class="row align-items-center">
                                <div class="col-sm-6 text-sm-left">
                                    <a :href="'https://www.fotografi-cameramani.ro' + member.author_url" target="_blank" class="member-link mb-2 mb-sm-0 align-items-center d-flex justify-content-center justify-content-sm-start">

                                        <PlaceBadge class="mr-2" :place="index" :primary="index <= 3"></PlaceBadge>

                                        <MemberPhoto :photo="member.author_img" class="photo mr-3"></MemberPhoto>
                                        <b>{{member.author_name}}</b>
                                    </a>
                                </div>
                                <div class="col-sm-6 text-sm-right text-center">
                                    <div class="d-inline-block">
                                        <b>{{member.points_total}}</b> puncte
                                    </div>
                                    <span v-if="member.place_advance > 0" class="ml-3 text-success">
                                        <i class="fas fa-chevron-up"></i> {{member.place_advance}} pozitii
                                    </span>
                                    <span v-if="member.place_advance < 0" class="ml-3 text-danger">
                                        <i class="fas fa-chevron-down"></i> {{member.place_advance}} pozitii
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row justify-content-center">
                                <div v-for="(award, index) in member.awards" v-bind:class="{'col-6 col-sm-3': $route.params.type == 'videografie', 'col-6 col-sm-2': $route.params.type == 'fotografie'}" class="text-center mb-4">
                                    <div class="material">
                                        <img :src="thumbUrl(award.material)" class="img-thumbnail">
                                    </div>
                                    <div class="d-inline-block award mt-1 mr-1">
                                        <PlaceBadge :place="award.loc" :primary="false" :size="'small'"></PlaceBadge>
                                    </div>
                                    <br/>
                                    <router-link class="awardedMaterial" :to="{name: 'category', params: {id: award.cat_index, type: $route.params.type}, hash: '#mat' + award.material_id}">
                                        <small>{{award.categorie}}</small>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center pt-4">
                    <router-link :to="{name: 'index'}" class="btn btn-lg btn-light w-100"><i class="fas fa-chevron-left"></i> Inapoi la categorii</router-link>
                </div>
            </div>
        </div>
        <PromoMembers></PromoMembers>
        <PromoClients></PromoClients>
        <Stt></Stt>
    </div>
</template>

<script>

import Header from '../components/snippets/Header.vue'
import Stt from '../components/snippets/Stt.vue'
import TypesMenu from '../components/snippets/TypesMenu.vue'
import PromoMembers from '../components/snippets/PromoMembers.vue'
import PromoClients from '../components/snippets/PromoClients.vue'
import MemberPhoto from '../components/snippets/MemberPhoto.vue'
import PlaceBadge from '../components/snippets/PlaceBadge.vue'

import { mapState, mapActions, mapGetters } from 'vuex'

export default {
    name: 'Ranks',
    components: {
        Header,
        Stt,
        TypesMenu,
        PromoMembers,
        PromoClients,
        MemberPhoto,
        PlaceBadge
    },
    metaInfo() {
        return {
            title: "Clasament - Concursul anual 2020 - Fotografi-Cameramani.ro",
            meta: [
                {name: 'description', content: 'Clasament - Concursul anual 2020 - Fotografi-Cameramani.ro'},
                {property: 'og:title', content: "Clasament - Concursul anual 2020 - Fotografi-Cameramani.ro"},
                {property: 'og:site_name', content: 'Clasament - Fotografi-Cameramani.ro'},
                {property: 'og:type', content: 'website'},
            ]
        }
    },
    props: {
    },
    computed: {
        ...mapGetters('general', {
            rank: 'rank',
        }),

    },
    data: function() {
        return {}
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions('general', {
            getBatch: 'getBatch'
        }),

        init() {
            this.getBatch(this.$route.params.type);

            // $(function () {
            //     $('[data-toggle="tooltip"]').tooltip()
            // })
        },

        thumbUrl(imagine) {

            if(this.$route.params.type == 'fotografie') {
                return 'https://www.fotografi-cameramani.ro/upload/photos/imagine/thumb/' + imagine;
            }

            if(this.$route.params.type == 'videografie') {
                return 'https://www.fotografi-cameramani.ro/upload/filme/imagine/slide/' + imagine;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

.award {
    // background: #F7AD0C;
    // border-radius: 3px;
    display: inline-block;
    // color: black;
    // font-size: 90%;
    padding: 1px 5px;

    .placebadge {
        margin-top: -25px !important;
    }
}

.awardedMaterial {
    color: #333;

    &:hover {
        text-decoration: none;
    }
}

.photo {
    max-width: 50px;
}

.material img {
    max-height: 94px;
}

</style>
